module.exports = __webpack_public_path__ + "img/sprinkle-19.2cf1599a.jpg";